type Id = bigint | number | string;

/**
 * Whether a job's provider or receiver is own, for a write, which fails closed: true when a set org is the active company or
 * (the subtree known) one of its descendants, false when the subtree shows none is,
 * undefined while the subtree is unknown and none is the active company itself.
 */
export const isAnyOwnOrganizationForWrite = (
  ids: (Id | null | undefined)[],
  activeCompanyId: Id | null | undefined,
  subtree?: { id: bigint }[],
): boolean | undefined => {
  const set = ids.filter((id) => String(id ?? 0) !== "0");
  if (set.length === 0 || set.some((id) => String(id) === String(activeCompanyId))) return true;
  return subtree
    ? set.some((id) => subtree.some((org) => String(org.id) === String(id)))
    : undefined;
};

/** The list with the item appended unless it already holds its id: a record from another org's list. */
export const withItem = <T extends { id: Id }>(items: T[], item?: T | null): T[] =>
  item && !items.some((it) => String(it.id) === String(item.id)) ? [...items, item] : items;
